import React, { useReducer, useEffect } from "react";
import {
    MapContainer,
} from "react-leaflet";
import { reducer, initialState, Context } from '../../store/reducer';
import NormalHeader from '../../components/Header/normal';
import MapController from '../../components/MapController';
import VectorGrid90 from "../../components/VectorGrid90";
import FirstInformationModal from '../../components/FirstInformationModal';
import { mapConfig } from '../../config/env';
import { tmptestAPI} from "../../utils/api";
import { kashika4Options } from "../../components/Header/normal/kashika4config";
import MapUpdate from "../../components/MapUpdate";
import MapClick from "../../components/MapClick";
import Geocoder from "../../components/Geocoder";
import Popup90 from "../../components/Spot/menu/popup90";
import Popup90_15 from "../../components/Spot/menu/popup90_15";
import Popup90_16_5 from "../../components/Spot/menu/popup90_16_5";
import popupDefault from "../../components/Spot/menu/popupDefault";
import PopupDefault from "../../components/Spot/menu/popupDefault";
import Vis90_16_5InformationModal from "../../components/Vis90_16_5InformationModal";
import MenuSpot from "../../components/Spot/menu";

// 90_16_5 既存盛土等（法第4条第1項）の非公開データ
import Data_90_16_5 from '../../assets/data/90_16_5_data.json';
import VectorGrid90_4 from "../../components/VectorGrid90_4";

const Layout = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        
        // 90_16_5 既存盛土等（法第4条第1項）の非公開データをassetフォルダのjsonから取得する。
        dispatch({
            type: 'SET_DATA',
            category: "vis_90_16_5",
            payload: Data_90_16_5
        });
        
        kashika4Options.map(menu =>{
            menu.options.map(options => {
                
                if (options.hasChild) {
                
                    // サブレイヤーがある場合の処理
                    options.subLayers.map(subOption => {

                        if (subOption.type == 'marker'){

                            // マーカーの場合、urlが空の場合はAPIを叩かない
                            if (subOption.url == "") {
                                return;
                            }

                            // APIから取得する
                            tmptestAPI.get(subOption.url)
                            .then(res=>{
                                dispatch({
                                    type: 'SET_DATA',
                                    category: subOption.id,
                                    payload: res.data
                                });
                            })
                        }
                    })
                    
                } else {

                    if (options.type == 'marker'){

                        // マーカーの場合、urlが空の場合はAPIを叩かない
                        if (options.url == "") {
                            return;
                        }

                        // APIから取得する
                        tmptestAPI.get(options.url)
                        .then(res=>{
                            dispatch({
                                type: 'SET_DATA',
                                category: options.id,
                                payload: res.data
                            });
                        })
                    }
                }
                
            })
        })
        
        // APIから法令情報を取得する。
        tmptestAPI.get(process.env.REACT_APP_LAW_JSON)
        .then(res=>{
            dispatch({
                type: 'SET_90_LAW_DATA',
                payload: res.data
            });
        })

        tmptestAPI.get(process.env.REACT_APP_MENU)
        .then(res=>{
            // console.log(res)
            dispatch({
                type: 'SET_MENU',
                payload: res.data
          });
        })

    }, [])
    
    return (
        <Context.Provider value={{ state, dispatch }}>
            <NormalHeader />
            <main className="main">
                <div className="main-inner">
                    
                    <FirstInformationModal></FirstInformationModal>
                    

                    {
                      // 盛り土関係のモーダル。メニューチェック時にのみ表示される。
                      // 最初期に実装したメニュー「vis_90_16_5」のisCheckedInModalを確認するだけとしている。
                        (
                            (state["vis_90_16_5"].checked
                                || state["vis_90_16_4"].checked
                                || state["vis_90_16_3"].checked
                                || state["vis_90_16_2"].checked
                                || state["vis_90_16_1"].checked)
                            && ! state["vis_90_16_5"].isCheckedInModal
                        )
                      &&
                    	<Vis90_16_5InformationModal></Vis90_16_5InformationModal>
                    }



                    <MapContainer
                        tap={false}
                        id="map"
                        {...mapConfig}
                    >
                        <Geocoder/>
                        <MapUpdate />
                        <MapController />

                        <MapClick />
                        
                        {kashika4Options.map(menu => {
                            
                            return menu.options.map(options => {

                                if(options.type == "vector" && state[options.id].checked) {

                                    if (['vis_90_16_1','vis_90_16_2'].includes(options.id)
                                    && ! state["vis_90_16_5"].isCheckedInModal) {

                                        // 判定条件に注意。モーダルでの確認（＝閉じる）がされていない場合は何も表示しないということ。

                                        return <></>

                                    } else if(options.id == "vis_90_4" && state[options.id].checked) {
                                        // 地すべり等防止法 (可視化2の地すべり危険箇所（77_3_jisuberi）と同じ内容を表示する)

                                        return <VectorGrid90_4
                                            id={"vis_90_4"}
                                            url={options.url}
                                            layerName={options.layerName}
                                            url2={options.url2}
                                            layerName2={options.layerName2}
                                            url3={options.url3}
                                            layerName3={options.layerName3}
                                            color={options.color}
                                            borderColor={options.borderColor}
                                        />

                                    } else {
                                        return <VectorGrid90
                                            id={options.id}
                                            url={options.url}
                                            layerName={options.layerName}
                                            color={options.color}
                                            opacity={options.opacity}
                                            borderColor={options.borderColor}
                                        />
                                    }

                                } else if(options.type == "marker" && state[options.id].checked) {

                                    if (options.id === 'vis_90_15') {
                                        return state[options.id].data.spots.map((d, index) =>
                                          <Popup90_15
                                            key={index.toString()}
                                            option={options}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                          />
                                        )
                                        
                                    } else if (options.id === 'vis_90_3') {
                                        
                                        return state[options.id].data.spots.map((d, index) =>
                                          <Popup90
                                            key={index.toString()}
                                            option={options}
                                            spot={d}
                                            latitude={d[options.column_lat]}
                                            longitude={d[options.column_lng]}
                                            menu={options.label}
                                            draggable={false}
                                          />
                                        )
                                        
                                    } else if (options.id === 'tameike') {

                                        return state[options.id].data.spots.map((d, index) =>
                                          <MenuSpot
                                            key={d["ため池番号"]}
                                            spot={d}
                                            latitude={d["緯度"]}
                                            longitude={d["経度"]}
                                            menu={options.label}
                                            draggable={false}
                                          />
                                        )

                                    } else {

                                        // 既存盛土等の5メニュー
                                        if (['vis_90_16_3','vis_90_16_4','vis_90_16_5'].includes(options.id)) {

                                            // モーダルでの同意時にのみ表示する。
                                            if (state['vis_90_16_5'].isCheckedInModal) {

                                                if (['vis_90_16_5'].includes(options.id)) {
                                                    return state[options.id].data.spots.map((d, index) =>
                                                        <Popup90_16_5
                                                            key={index.toString()}
                                                            option={options}
                                                            spot={d}
                                                            latitude={d[options.column_lat]}
                                                            longitude={d[options.column_lng]}
                                                            menu={options.label}
                                                            draggable={false}
                                                        />
                                                    )
                                                } else {
                                                    // 許可盛り土、届出盛土は通常の汎用ポップアップ
                                                    return state[options.id].data.spots.map((d, index) =>
                                                        <PopupDefault
                                                            key={index.toString()}
                                                            option={options}
                                                            spot={d}
                                                            latitude={d[options.column_lat]}
                                                            longitude={d[options.column_lng]}
                                                            menu={options.label}
                                                            draggable={false}
                                                        />
                                                    )
                                                }


                                            }
                                        } else {  

                                            /*
                                             * CSVの中身を緯度経度以外全て出力する汎用的なマーカー用コンポーネント
                                             * ・盛り土
                                             */
                                         
                                            return state[options.id].data.spots.map((d, index) =>
                                            <PopupDefault
                                                key={index.toString()}
                                                option={options}
                                                spot={d}
                                                latitude={d[options.column_lat]}
                                                longitude={d[options.column_lng]}
                                                menu={options.label}
                                                draggable={false}
                                            />
                                            )
                                        }

                                    }
                                    
 
                                } else if (options.hasChild) {
                                    
                                    return options.subLayers.map(subLayerOption => {

                                        if(subLayerOption.type == "vector" && state[subLayerOption.id].checked) {

                                            return <VectorGrid90
                                              id={subLayerOption.id}
                                              url={subLayerOption.url}
                                              layerName={subLayerOption.layerName}
                                              color={subLayerOption.color}
                                              opacity={subLayerOption.opacity}
                                              borderColor={subLayerOption.borderColor}
                                            />
                                        } else if(subLayerOption.type == "marker" && state[subLayerOption.id].checked) {
                                            
                                            return state[subLayerOption.id].data.spots.map((d, index) =>
                                              <PopupDefault
                                                key={index.toString()}
                                                option={subLayerOption}
                                                spot={d}
                                                latitude={d[subLayerOption.column_lat]}
                                                longitude={d[subLayerOption.column_lng]}
                                                menu={subLayerOption.label}
                                                draggable={false}
                                              />
                                            )
                                        }
                                    })
                                    
                                }
                                
                            })
                        })}
                        
                    </MapContainer>

                </div>
            </main>
        </Context.Provider>
    )
}

export default Layout;
